$(document).ready(function(){
	if ($(".desktop_image_banner_index_page")[0] || $(".mobile_image_banner_index_page")[0]){
            $('.desktop_image_banner_index_page').css('opacity', 0);
            $('.mobile_image_banner_index_page').css('opacity', 0);
            var random_image_count = parseInt($('.random_image_count_for_banner').attr('random_image_count'));
            const MAX_VISIT_NUMBER = random_image_count; // Set your desired maximum number here (e.g., 7, 8, 10)
            const currentPagePath = (window.location.pathname).replace('/', '');
            const LOCAL_STORAGE_KEY = 'pageVisitCounter_' + currentPagePath+'_ele';

            let currentVisit = parseInt(localStorage.getItem(LOCAL_STORAGE_KEY));

            if (isNaN(currentVisit) || currentVisit === null) {
                currentVisit = 1;
            } else {
                currentVisit++;

                if (currentVisit > MAX_VISIT_NUMBER) {
                    currentVisit = 1;
                }
            }

            localStorage.setItem(LOCAL_STORAGE_KEY, currentVisit);

            var desk = $('.random_images_values_for_main_banner[data_index="'+currentVisit+'"]').attr('deskscr');
            var mob = $('.random_images_values_for_main_banner[data_index="'+currentVisit+'"]').attr('mobscr');
            $('.desktop_image_banner_index_page').attr('src', desk);
  
            $('.mobile_image_banner_index_page').attr('src', mob);
            setTimeout(function() {
              $('.desktop_image_banner_index_page').css('opacity', 1);
              $('.mobile_image_banner_index_page').css('opacity', 1);              
            }, 400)
    }

  
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

  $('.tone_popup').click(function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RWhhu5']);
  });
 

  $('.size_k_popup').click(function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'XaXaHQ']);
  });


  $('.gift_k_popup').click(function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RzkffQ']);
  });

  setTimeout(function() {    
    $('form#customer_login input[name="checkout_url"]').val('/account');
  }, 20);

  function create_custom_dropdowns() {
    $('select.cst').each(function(i, select) {
      if (!$(this).next().hasClass('dropdown')) {
        $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
        var dropdown = $(this).next();
        var options = $(select).find('option');
        var selected = $(this).find('option:selected');
  
          var sel = selected.data('display-text') || selected.text();
          var hnc = sel;
          if (hnc) {
            hnc = hnc.toLowerCase();
            hnc = hnc.trim();
          }
          var img = '<img src=https://cdn.shopify.com/s/files/1/0526/4769/0439/files/flag_'+hnc+'1.png?ds=ds />';
        
        dropdown.find('.current').html(sel + img);
        options.each(function(j, o) {
          var display = $(o).data('display-text') || '';
          var hn = $(o).text();
          if (hn) {
            hn = hn.toLowerCase();
            hn = hn.trim();
          }
          var img = '<img src=https://cdn.shopify.com/s/files/1/0526/4769/0439/files/flag_'+hn+'1.png?ds=dss />';
          dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + img + '</li>');
        });
      }
    });
  }
  
// Event listeners

// Open/close
$(document).on('click', '.dropdown', function(event) {
  $('.dropdown').not($(this)).removeClass('open');
  $(this).toggleClass('open');
  if ($(this).hasClass('open')) {
    $(this).find('.option').attr('tabindex', 0);
    $(this).find('.selected').focus();
  } else {
    $(this).find('.option').removeAttr('tabindex');
    $(this).focus();
  }
});
// Close when clicking outside
$(document).on('click', function(event) {
  if ($(event.target).closest('.dropdown').length === 0) {
    $('.dropdown').removeClass('open');
    $('.dropdown .option').removeAttr('tabindex');
  }
  event.stopPropagation();
});
// Option click
$(document).on('click', '.dropdown .option', function(event) {
  $(this).closest('.list').find('.selected').removeClass('selected');
  $(this).addClass('selected');
  var text = $(this).data('display-text') || $(this).text();
  $(this).closest('.dropdown').find('.current').text(text);
  $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
  $(this).closest('.dropdown').prev('select').val($(this).data('value')).change();
});

// Keyboard events
$(document).on('keydown', '.dropdown', function(event) {
  var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
  // Space or Enter
  if (event.keyCode == 32 || event.keyCode == 13) {
    if ($(this).hasClass('open')) {
      focused_option.trigger('click');
    } else {
      $(this).trigger('click');
    }
    return false;
    // Down
  } else if (event.keyCode == 40) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      focused_option.next().focus();
    }
    return false;
    // Up
  } else if (event.keyCode == 38) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
      focused_option.prev().focus();
    }
    return false;
  // Esc
  } else if (event.keyCode == 27) {
    if ($(this).hasClass('open')) {
      $(this).trigger('click');
    }
    return false;
  }
});
  create_custom_dropdowns();

  $('.localization-selector').change(function() {
    $(this).parent().parent('form').submit();
  });

  $('button.afbfbtn').click(function() {
    var at = $(this).attr('data-atr');
    at = at.trim();
    $('button.afbfbtn').removeClass('active');
    $(this).addClass('active');
  
    if ($('img[da-atrc=afterimg]') != undefined) {
      $('img[da-atrc=afterimg]').hide();
    }
    if ($('img[da-atr-afimg='+at+']') != undefined) {
      $('img[da-atr-afimg='+at+']').show();
    }
    $('#updatevidesrc source').attr('src', $('.updatevidesrcip[data-video-attr='+at+']').val());
    
  
    if ($('input[bfimg='+at+']') != undefined) {
    var currentClickImg = $('input[bfimg='+at+']').val();
      if (currentClickImg) {
        $('img[da-atr-bfimg=before]').attr('src', currentClickImg);
      }
    }
    const video = document.getElementById('updatevidesrc');
    video.src = $('.updatevidesrcip[data-video-attr='+at+']').val();
    video.load();
    video.play();
    // setTimeout(function() {    
    //   $('#updatevidesrc').load();
    // }, 50);
  });

  
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 768) {
           $('.ugc-videos-inner').addClass('owl-carousel');
           $('.ugc-videos-inner').owlCarousel({            
            loop: false,
            nav: false,
            dots: false,
            margin: 20,
            items: 1,
            stagePadding: 30
          });
        }
    }
  
    $('.video_poster_img').mouseover(function() {
      $('.video_poster_img').removeClass('hideback');
      $('.playbtn').show();
      $('.videin').each(function() {
          $(this).get(0).pause();
      });
      $(this).parents('.ugc-video-item').find('.videin')[0].play();
      $(this).parents('.ugc-video-item').find('.playbtn').hide();
      
      $(this).addClass('hideback');
    })
  

  $('.carousel-before-after-wrapper.owl-carousel').owlCarousel({        
    nav: true,
    dots: true,
    loop: true,
    items: 1,
    autoplay: true,
    onInitialized: startProgressBar,
    onTranslate: resetProgressBar,
    onTranslated: startProgressBar
  });

  $('.owl-dots button').html('<div class="slide-progress" style="width: 0; transition: width 0ms;"></div>');
  $('.owl-dots button.active').html('<div class="slide-progress" style="width: 100%; transition: width 5000ms"></div>');
  $('.carousel-before-after-wrapper .owl-nav .owl-prev').html('← Back');
  $('.carousel-before-after-wrapper .owl-nav .owl-next').html('Next →');

  
  function startProgressBar() {
    // apply keyframe animation
    $(".owl-dot.active .slide-progress").css({
      width: "100%",
      transition: "width 5000ms"
    });
  }
  
  function resetProgressBar() {
    $(".owl-dot .slide-progress").css({
      width: 0,
      transition: "width 0ms"
    });
  }

    $('.products-carousel_obj.owl-carousel').owlCarousel({        
      loop: false,
      nav: false,
      dots: true,
      items: 1,
      autoplay: true,
      margin: 15
    });
  
  $(document).on('click', '.Faq__Question', function(event) {
    var $item = $(this).closest('.Faq__Item');
    $(this).siblings('.Faq__AnswerWrapper').slideToggle();

    if ($item.attr('aria-expanded') === 'true') {
      $(this).closest('.Faq__Item').attr('aria-expanded', 'false');
      $item.find('.Faq__AnswerWrapper').attr('aria-hidden', 'true');
    } else {
      $(this).closest('.Faq__Item').attr('aria-expanded', 'true');
      $item.find('.Faq__AnswerWrapper').attr('aria-hidden', 'false');
    }
  });

  $(".ugc-video-item").hover(
    function () {
      $(".ugc-video-item").removeClass("active");
      $(this).addClass("active");
    },
    function () {
      // $(this).removeClass("result_hover");
    }
  );

  $(document).on('click', '.add-upsell-btn-in', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var that = $(this);
    if (that.hasClass('propage') && $(this).attr('disabled')) {              
      return;
    }
    const cartLink = document.querySelector('#cart-icon-bubble');
    $(this).find('span').hide();
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    
    var id = $(this).attr('dataid');
    var items = 
      {
       id: id,
       quantity: 1
      };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: items,
      success: function(res) {
        $.ajax({
          type: 'GET',
          url: `${routes.cart_url}?view=fullcartdrawer`,
          success: function(htm) {
            $('cart-drawer').removeClass('is-empty');
            $('cart-drawer').html(htm);
            that.find('span').show();
            that.find('.loading-overlay__spinner').addClass('hidden');
            $('.modal').removeClass('is-visible');
            // if (that.hasClass('propage')) {
              $('cart-drawer').addClass('animate active')
            // }
            $('.carousel_upsell').owlCarousel({
              margin:10,
              nav:false,
              autoplayTimeout: 3500,
              autoplayHoverPause: true,
              items: 1,
              stagePadding: 40
            });   
          },
          error: function(err) {
            console.log(err);   
            that.find('span').show();
            that.find('.loading-overlay__spinner').addClass('hidden');               
          }
        });          
        
        jQuery.getJSON('/cart.js', function(cart) {
          if ($('.cart-count-bubble')[0]) {
            $('.cart-count-bubble span').html(cart.item_count);
          } else {
            var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span> </div>'
            $('#cart-icon-bubble').append(dt);
          }
          cartLink.click();
        });
        
      },
      error: function(err) {
        console.log(err);      
        that.find('span').show();
        that.find('.loading-overlay__spinner').addClass('hidden');            
      }
    });
  });  
});
